module.exports = __webpack_public_path__ + "img/logo3.1bfd961f.png";